import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  LinearProgress,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import configServ from "../../services/config";

const questions = [
  "How is your pain now?",
  "How do you feel after the session?",
  "Any discomfort remaining?",
  "Would you recommend this therapy?",
];

const AdminFeedbackPanel = () => {
  const { customer_id } = useSelector((state) => state.GlobalVariables);
  const [feedbackData, setFeedbackData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFeedback = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await configServ.getFeedback({ user_id: customer_id });
        if (response.success === true) {
          const formattedData = response.data.map((item) => ({
            id: item.id,
            date: new Date(item.created_at).toLocaleDateString(), // Format date
            comment: item.comment,
            painLevels: JSON.parse(item.pain_levels), // Convert string to array
          }));
          setFeedbackData(formattedData);
        } else {
          throw new Error("Failed to fetch feedback");
        }
      } catch (error) {
        console.error("Error fetching feedback:", error);
        setError("Failed to fetch feedback. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (customer_id) {
      fetchFeedback();
    }
  }, [customer_id]);

  return (
    <TableContainer component={Paper}>
      {loading ? (
        <div style={{ textAlign: "center", padding: "20px" }}>
          <CircularProgress />
          <Typography variant="body2">Loading feedback...</Typography>
        </div>
      ) : error ? (
        <Typography variant="body2" color="error" style={{ padding: "20px" }}>
          {error}
        </Typography>
      ) : feedbackData.length === 0 ? (
        <Typography variant="body2" style={{ padding: "20px", textAlign: "center" }}>
          No feedback available.
        </Typography>
      ) : (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <strong>Date</strong>
              </TableCell>
              <TableCell>
                <strong>Comments</strong>
              </TableCell>
              {questions.map((question, index) => (
                <TableCell key={index}>
                  <strong>{question}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {feedbackData.map((feedback) => (
              <TableRow key={feedback.id}>
                <TableCell>{feedback.date}</TableCell>
                <TableCell>{feedback.comment}</TableCell>
                {feedback.painLevels.map((level, idx) => (
                  <TableCell key={idx}>
                    <Typography variant="body2" color="textSecondary">
                      {level}%
                    </Typography>
                    <LinearProgress variant="determinate" value={level} />
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};

export default AdminFeedbackPanel;
